export default {
    mounted(el, binding) {
        const callback = binding.value;
        const observer = new IntersectionObserver((entries) => {
            callback(entries);
        }, { rootMargin: '100px' }); // Начинать загрузку за 100px до появления
        
        observer.observe(el);
        el._observer = observer; // Сохраняем, чтобы потом удалить
    },
    unmounted(el) {
        el._observer?.disconnect();
    }
};